import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Innovations from '../../components/Innovations';
import Milestones from '../../components/Milestones';
import useTeamMembers from '../../hooks/useTeamMembers';
import { Helmet } from 'react-helmet';

const MileStonesPage = () => {
  const { times } = useTeamMembers();
  return (
    <div style={{ padding: '4rem 0 4rem 0', background: '#fff' }}>
      <Helmet>
        <title>Milestones | Solaric</title>
      </Helmet>
      <Breadcrumb current='Milestones' previous='about' />
      <div style={{ paddingTop: '1rem' }}>
        <Milestones times={times} />
      </div>
    </div>
  );
};

export default MileStonesPage;
